import type { FloraStepperItemStyleSemantic } from '@grupoboticario/flora-react'

import { ACCELERATION_STEP_INDEX } from '@/constants/accelerationStepper'

import type {
  AccelerationFormState,
  AccelerationStepperVariant,
  AccelerationStepReadOnlyFlags
} from '../AccelerationForm.types'
import { validateStepDetails, validateStepDesign, validateStepScoring } from '../validation/accelerationFormValidation'

export function getStepStyleSemantic(stepIndex: number, currentStep: number): FloraStepperItemStyleSemantic {
  if (stepIndex < currentStep) {
    return 'checked'
  }
  if (stepIndex === currentStep) {
    return 'current'
  }
  return 'disabled'
}

export function isCurrentStepValidForNavigation(
  currentStep: number,
  formState: AccelerationFormState,
  stepReadOnly: AccelerationStepReadOnlyFlags,
  variant: AccelerationStepperVariant
): boolean {
  if (currentStep === ACCELERATION_STEP_INDEX.POINTS && stepReadOnly.configuration) {
    return true
  }
  if (currentStep === ACCELERATION_STEP_INDEX.VISUAL && stepReadOnly.visual) {
    return true
  }
  if (currentStep === ACCELERATION_STEP_INDEX.DETAILS && stepReadOnly.details) {
    return true
  }

  if (currentStep === ACCELERATION_STEP_INDEX.POINTS) {
    return validateStepScoring(formState)
  }
  if (currentStep === ACCELERATION_STEP_INDEX.VISUAL) {
    return validateStepDesign(formState.content, formState.brand, formState.contentByBrand, variant)
  }
  if (currentStep === ACCELERATION_STEP_INDEX.DETAILS) {
    return validateStepDetails(formState.content.details)
  }

  return false
}

export type AccelerationStepperLabelItem = { id: string; text: string }

export function buildFloraSteps(
  labels: readonly AccelerationStepperLabelItem[],
  currentStep: number,
  isEditing: boolean
) {
  return labels.map((step, index) => ({
    ...step,
    isFilled: isEditing ? index <= currentStep : index < currentStep,
    styleSemantic: getStepStyleSemantic(index, currentStep)
  }))
}
